export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";